import { isPlatformServer } from '@angular/common';
import { ɵDomAdapter as DomAdapter, ɵgetDOM as getDOM } from '@angular/platform-browser';
var HrefLang = /** @class */ (function () {
    function HrefLang(_doc, platformId) {
        this._doc = _doc;
        this.platformId = platformId;
        this._dom = getDOM();
    }
    HrefLang.prototype.addLang = function (lang) {
        if (isPlatformServer(this.platformId)) {
            this._dom.setAttribute(this._doc.head.parent, 'lang', lang);
        }
    };
    HrefLang.prototype.addTags = function () {
        var _this = this;
        var tags = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            tags[_i] = arguments[_i];
        }
        if (isPlatformServer(this.platformId)) { // Avoid readding the meta tags in client
            var presentTags = this._flattenArray(tags);
            if (presentTags.length === 0)
                return [];
            return presentTags.map(function (tag) { return _this._addInternal(tag); });
        }
    };
    HrefLang.prototype._addInternal = function (tag) {
        var meta = this._createLinkElement();
        this._prepareMetaElement(tag, meta);
        this._appendMetaElement(meta);
        return meta;
    };
    HrefLang.prototype._createLinkElement = function () {
        return this._dom.createElement('link');
    };
    HrefLang.prototype._prepareMetaElement = function (tag, el) {
        var _this = this;
        Object.keys(tag).forEach(function (prop) { return _this._dom.setAttribute(el, prop, tag[prop]); });
        return el;
    };
    HrefLang.prototype._appendMetaElement = function (meta) {
        var head = this._doc.head;
        try {
            this._dom.removeChild(head, meta);
        }
        catch (ex) { }
        this._dom.appendChild(head, meta);
    };
    HrefLang.prototype._flattenArray = function (input, out) {
        if (out === void 0) { out = []; }
        if (input) {
            for (var i = 0; i < input.length; i++) {
                var item = input[i];
                if (Array.isArray(item)) {
                    this._flattenArray(item, out);
                }
                else if (item) {
                    out.push(item);
                }
            }
        }
        return out;
    };
    return HrefLang;
}());
export { HrefLang };
